import { Reviewable } from "../types";

/**
 * Given a project, determine if it contains any HUG family badges
 */
const hasHugBadge = (project?: Reviewable) => {
  if (!project || !project.badges || project.badges.length === 0) return false;

  return !!project.badges.find(
    (b) => b.match(/hedge/i) || b.match(/2022/i) || b.match(/grad/i)
  );
};

export { hasHugBadge };
